import React from "react";
import "./Return_order_details_table.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { Table } from "react-bootstrap";
import { variant_type } from "../../../../../utils/common";

function Return_order_details_table({ order, dontShowPrice }) {
  return (
    <>
      {order?.Return_Order_Details?.map((order) => (
        <div className="product_content_holder">
          <div className="product_content">
            <div className="product_detail_inner">
              <div className="left_side">
                <div className="img_holder">
                  <img
                    src={
                      process.env.REACT_APP_IMG_URL +
                      order?.Product_Order_Detail?.Product?.image
                    }
                  />
                </div>

                <div className="text_holder">
                  <div className="product_name">
                    <p>{order?.Product_Order_Detail?.Product?.name}</p>
                  </div>
                  {/* <div className="weight"> */}
                  <h6>
                    {order?.Product_Order_Detail?.Product?.variant_type_id ===
                      variant_type.Single && (
                      <>
                        <strong>Mattress Size:</strong>{" "}
                        {
                          order?.Product_Order_Detail?.Product_Variant?.Metal
                            ?.name
                        }
                      </>
                    )}

                    {order?.Product_Order_Detail?.Product?.variant_type_id ===
                      variant_type.Double && (
                      <>
                        <strong>Mattress Size:</strong>{" "}
                        {
                          order?.Product_Order_Detail?.Double_Variant
                            ?.Product_Variant?.Metal?.name
                        }
                        , <strong>Thickness:</strong>{" "}
                        {
                          order?.Product_Order_Detail?.Double_Variant?.Size
                            ?.name
                        }{" "}
                      </>
                    )}

                    {order?.Product_Order_Detail?.Product?.variant_type_id ===
                      variant_type.Triple && (
                      <>
                        <p className="sub_text">
                          <strong>Mattress Size:</strong>{" "}
                          {
                            order?.Product_Order_Detail?.Triple_Variant
                              ?.Double_Variant?.Product_Variant?.Metal?.name
                          }
                          ,
                          {
                            order?.Product_Order_Detail?.Triple_Variant
                              ?.Double_Variant?.Size?.name
                          }
                          ,{" "}
                        </p>
                        <p className="sub_text">
                          <strong>Thickness:</strong>{" "}
                          {
                            order?.Product_Order_Detail?.Triple_Variant?.Diamond
                              ?.name
                          }
                        </p>
                      </>
                    )}
                  </h6>
                  {/* </div> */}
                </div>
              </div>

              <div>
                <div className="qty_holder">
                  <p>
                    X{order?.Product_Order_Detail?.quantity}{" "}
                    {!dontShowPrice && (
                      <span className="price">
                        ₹
                        {Number(
                          order?.Product_Order_Detail?.selling_price,
                        ).toFixed(2)}
                      </span>
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* <div className='product_content_holder'>
        <div className='product_content'>
          <div className='product_detail_inner'>
            <div className='left_side'>
              <div className='img_holder'>
                <img
                  src={
                    process.env.REACT_APP_IMG_URL +
                    order?.Product_Order_Details?.Product?.image
                  }
                />
              </div>

              <div className='text_holder'>
                <div className='product_name'>
                  <p>{order?.Product_Order_Details?.Product_Variant?.name}</p>
                </div>
                <div className='weight'>
                  <p>{order?.total_kg}</p>
                </div>
              </div>
            </div>

            <div>
              <div className='qty_holder'>
                <p>x 1 {!dontShowPrice && <span className='price'>₹ 120</span>}</p>
              </div>
            </div>

          </div>

          <div className='product_detail_inner'>
            <div className='left_side'>
              <div className='img_holder'>
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/products/img2.png"
                  }
                />
              </div>

              <div className='text_holder'>
                <div className='product_name'>
                  <p>Apple</p>
                </div>
                <div className='weight'>
                  <p>0.5kg</p>
                </div>
              </div>
            </div>

            <div>
              <div className='qty_holder'>
                <p>x 1 {!dontShowPrice && <span className='price'>₹ 120</span>}</p>
              </div>
            </div>

          </div>
        </div>
      </div> */}
    </>
  );
}

export default Return_order_details_table;
